import React from "react"
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";
import {Col, Row} from "antd";
import AvatarSkeleton from "../../../components/skeletons/AvatarSkeleton";

export default function ForumSkeleton({close, getListing, setGetListing, id}) {
    return(
        <>
            <div className={"main_div_forum"}>
                <Row gutter={[16, 16]}>
                    <Col lg={12} xl={12} md={24}>
                        <div className="col_1_forum">
                            <div className="inner_div_col_1">
                                <div className="header">
                                    <h5>  <HeadingSkeleton height={15} maxWidth={120} /></h5>
                                    <div className="btn_div">
                                        <HeadingSkeleton height={10} maxWidth={100} />
                                    </div>
                                </div>
                                <div className="mt-5 table_list_height">
                                    <div className="main_div_table_comp">
                                        <div className="inner_div_table_comp">
                                            <Row>
                                                <Col lg={8} xl={8} md={8} className="table_col_custom">
                                                    <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                                                </Col>
                                                <Col lg={8} xl={8} md={8}>
                                                    <p className="para"><HeadingSkeleton height={10} maxWidth={100} /></p>
                                                </Col>
                                                <Col lg={8} xl={8} md={8}>
                                                    <div className="action_div">
                                                        {/*<div className="add_btn">*/}
                                                        {/*    <HeadingSkeleton height={10} maxWidth={100} />*/}
                                                        {/*</div>*/}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={12} xl={12} md={24}>
                        <div className="forum_profile_section">
                            <div className="inner_div_profile_forum">
                                <h3>
                                    <HeadingSkeleton height={10} maxWidth={100} />
                                </h3>
                                <h5 className={'mt-3'}><HeadingSkeleton height={10} maxWidth={100} /></h5>
                                <div className="inner_div_profile_map">
                                    <div className="user_profile">
                                        <div className="img_div">
                                          <AvatarSkeleton height={40} width={40}/>
                                        </div>
                                        <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="link_section">
                            <div className="inner_div_link">
                                <div className="link_header">
                                    <h3><HeadingSkeleton height={10} maxWidth={100} /></h3>
                                </div>
                                <div className="links_resource">
                                    <div className="links_resource_inner">
                                        <div className="link_title">
                                            <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                                            <p className="para">
                                                <a href={'#'}>
                                                    <HeadingSkeleton height={10} maxWidth={100} />
                                                </a>
                                            </p>
                                        </div>
                                        <div className="Icon_link">
                                            <HeadingSkeleton height={10} maxWidth={10} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

        </>
    )
}